module.exports = __webpack_public_path__ + "static/img/logoshifan.80906fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logoshifan.png
// module id = niOf
// module chunks = 1